import { Component, Inject } from '@angular/core';
import { LogDexieService, LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-error-log',
    templateUrl: './error-log.component.html',
    styleUrls: ['./error-log.component.scss'],
})
export class ErrorLogComponent {
    public logEntriesString: string;
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly dexieLogger: LogDexieService,
        public readonly modalInstance: BsModalRef,
    ) {
        this.dexieLogger
            .getAllLogEntries()
            .then((logEntries) => {
                const formattedEntriesArray = logEntries.map((logEntry) => {
                    return `${logEntry.toString()}`;
                });
                this.logEntriesString = formattedEntriesArray.join('\n');
            })
            .catch((error) => {
                this.logEntriesString = '';
                this.log.error(`[ErrorLogComponent](constructor) Error on loading log entries from database: ${error}`);
            });
    }
}
